function setError(error, prefix='LY') {
  try {
    return getExtendedError(error, prefix, null )
  }
  catch (e) {
    console.log('error setError: ' + e)
    return ''
  }
}

function getExtendedError(objectValue, prefix='LY', prevValue=null ) {
  let result = null
  if (objectValue["layer"]) {
    if (Object.values(objectValue["extended"]).length === 0) {
      return setPrefix(objectValue["layer"], prefix) + setNumber(objectValue)
    }
    result = getExtendedError(objectValue["extended"], prefix, objectValue)
    if (result) {
      return result
    }
  }else {
    // case only for layer 6, other layers does not have error_number key
    return setPrefix(prevValue["layer"], prefix) + setNumber(objectValue)
  }
  return result
}

function setPrefix(layer, prefix) {
  if (layer && prefix === 'LY') {
    return prefix + layer + '-'
  } else {
    return prefix + '_'
  }

}
function setNumber (error_number) {
  return error_number['error_number'] ? error_number['error_number'] : 0
}

export {setError}
